import { render } from "./DefaultInfoCard.vue?vue&type=template&id=0093135e"
import script from "./DefaultInfoCard.vue?vue&type=script&lang=js"
export * from "./DefaultInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__